/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/lib/api";
import type {
  GetTournamentsIdTeamsQueryResponse,
  GetTournamentsIdTeamsPathParams,
} from "../types/GetTournamentsIdTeams.ts";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
  ResponseConfig,
} from "@/shared/lib/api";
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const getTournamentsIdTeamsQueryKey = (
  id: GetTournamentsIdTeamsPathParams["id"] | undefined,
) => [{ url: "/tournaments/:id/teams", params: { id: id } }] as const;

export type GetTournamentsIdTeamsQueryKey = ReturnType<
  typeof getTournamentsIdTeamsQueryKey
>;

/**
 * @summary Получение списка всех команд, зарегистрированных в турнире
 * {@link /tournaments/:id/teams}
 */
export async function getTournamentsIdTeams(
  id: GetTournamentsIdTeamsPathParams["id"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetTournamentsIdTeamsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({ method: "GET", url: `/tournaments/${id}/teams`, ...requestConfig });
  return res;
}

export function getTournamentsIdTeamsQueryOptions(
  id: GetTournamentsIdTeamsPathParams["id"] | undefined,
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const queryKey = getTournamentsIdTeamsQueryKey(id);
  return queryOptions<
    ResponseConfig<GetTournamentsIdTeamsQueryResponse>,
    ResponseErrorConfig<Error>,
    ResponseConfig<GetTournamentsIdTeamsQueryResponse>,
    typeof queryKey
  >({
    enabled: !!id,
    queryKey,
    queryFn: async ({ signal }) => {
      return getTournamentsIdTeams(id!, {
        ...config,
        signal: config.signal ?? signal,
      });
    },
  });
}

/**
 * @summary Получение списка всех команд, зарегистрированных в турнире
 * {@link /tournaments/:id/teams}
 */
export function useGetTournamentsIdTeams<
  TData = ResponseConfig<GetTournamentsIdTeamsQueryResponse>,
  TQueryData = ResponseConfig<GetTournamentsIdTeamsQueryResponse>,
  TQueryKey extends QueryKey = GetTournamentsIdTeamsQueryKey,
>(
  id: GetTournamentsIdTeamsPathParams["id"] | undefined,
  options: {
    query?: Partial<
      QueryObserverOptions<
        ResponseConfig<GetTournamentsIdTeamsQueryResponse>,
        ResponseErrorConfig<Error>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: Client };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...resolvedOptions } = queryConfig;
  const queryKey =
    resolvedOptions?.queryKey ?? getTournamentsIdTeamsQueryKey(id);

  const query = useQuery(
    {
      ...getTournamentsIdTeamsQueryOptions(id, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<Error>> & {
    queryKey: TQueryKey;
  };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
